import { LuSearch } from "@/Components/Icons/Icons";
export default {
  row1 :[
  {
    column: "column1",
    rows: {
      row1: [
        {
          name: "exportProductEPCGSnoPartE",
          label: "Item SNo (Part E)(Export item)",
          component: "text-field",
          width:"25%",
            disabled : true,

        },
        {
          name: "exportProductEPCGExportQuantityUlicence",
          label: "Export Qty Under Licence",
          component: "text-field",
          width:"25%",
            disabled : true,

        },
        //   {
        //   name: "deecUnit",
        //   component: "text-field",
        //   width:"10%",
        //     disabled : true,

        // },

        
      ],


    }
  }
]
}

